<template>

	<section class="slim">

		<div class="side">
			<div class="image" :style="{backgroundImage: 'url('+sideBackgroundImage+')'}" v-if="!$mq.mobile">
				<slot name="image" />
			</div>
			<div class="quote box">
				<div><slot name="quote" /></div>
			</div>
		</div>

		<div class="content box bg" :style="{backgroundImage: 'url('+contentBackgroundImage+')'}" v-if="!$mq.mobile">
			<div class="inner"><slot name="content" /></div>
		</div>

	</section>

</template>

<script>

	export default {
		name: "ImageQuoteContent",
		props: {
			contentBackgroundImage: String,
			sideBackgroundImage: String
		}
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";

	section {
		display:flex; width:100%;
		@include media(small, large) {
			flex-direction:column-reverse;
		}
		@include media(large) {
			height:100vh;
		}
	}

	.side {
		display:flex; flex-direction:column; flex-basis:30%;
	}

	.image {
		flex:1; background-size:cover; background-position:center;
		@include media(small, large) {
			height:60vw; background-position:inherit;
		}
	}

	.quote {
		background:#ffffff; color:#FCB813;
		h4 {
			font-family: "oswald"; line-height:1.25; font-weight:400; position:relative; text-transform:uppercase;
		}
		cite {
			display:flex; align-items:center; color:#adaeb3; font-style:normal; font-size:1.5rem; line-height:1.28; margin-top: 1.5rem;
			i {
				margin-right:.8rem;
			}
		}
	}


	.content {
		flex:1; color:#fff; background-size:cover; background-position:center;
		@include media(small, large) {
			background-position:right;
		}
	}

	.inner {
		@include media(small, large) {
			margin:0; padding-top:3.2rem; padding-bottom:8.6rem;
		}
	}

	.box {
		display:flex; align-items:center;
		@include media(small, large) {
			padding:0 5vw;
		}
		&.quote {
			padding-top:6vh; padding-bottom:6vh;
			@include media(large) {
				padding:6vh 4vw;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/ImageQuoteContent.vue